import { LayoutConst } from "core";
import { Colors, DropdownListItem, FlexBox, MEDIA } from "@brg/ui";
import styled, { createGlobalStyle } from "styled-components";

export const ApplicationEditorSortableDragStyles = createGlobalStyle`
  .application-editor-sortable-dragged {
    opacity: 1 !important;
    visibility: visible !important;
    z-index: 300100 !important;
    cursor: grabbing !important;
    pointer-events: none;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  }

  tr.application-editor-sortable-dragged {
    display: table;
    width: 100%;
    table-layout: fixed;
    background: #343434 !important;
  }

  tr.application-editor-sortable-dragged td {
    display: table-cell !important;
    vertical-align: middle;
    background: #343434 !important;
  }

  div.application-editor-sortable-dragged {
    width: 100%;
  }

  @media ${MEDIA.MOBILE} {
    tr.application-editor-sortable-dragged {
      display: flex !important;
      flex-flow: column;
      gap: 16px;
      padding: 12px 0;
    }

    tr.application-editor-sortable-dragged td {
      display: block !important;
      width: 100%;
      padding: 0 !important;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  max-width: ${LayoutConst.projectContainer.l}px;
  margin: 0 auto;
  gap: 48px;
  // overflow-y: scroll;
  // height: 100%;
  // margin-bottom: 300px;

  .ui-input_container {
    background-color: ${Colors.zelWhite10};
  }

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    margin-top: 40px;
    max-width: ${LayoutConst.projectContainer.m}px;
  }

  @media ${MEDIA.TABLET}px {
    // padding: 0 20px;
    max-width: calc(100% - 20px);
    margin: 40px auto 0 auto;
  }
`;

export const TdInputContainer = styled.tr`
  div:has(> input[type="checkbox"]) {
    background-color: ${Colors.zelWhite10};
  }

  ${DropdownListItem} {
    background-color: ${Colors.zelWhite10};
    text-align: left;
  }

  @media ${MEDIA.MOBILE} {
    display: inline-flex;
    flex-flow: column;
    gap: 16px;
    padding: 12px 0px;
  }
`;

export const GroupsInputsContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 24px;
  padding: 24px;
  border-radius: 3px;
  border: 1px solid ${Colors.galBlack47};

  div:has(> input[type="checkbox"]) {
    background-color: ${Colors.zelWhite10};
  }

  @media ${MEDIA.MOBILE} {
    padding: 16px 12px;
  }
`;

export const Table = styled.table`
    border-collapse: collapse;
    width: 100%;

    .id-input {
      max-width: 90px;
      min-width: 90px;
    }

    .checkbox-with-label {
        div:last-child {
            white-space: nowrap;
            color: rgba(144, 144, 144, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }
    }


    td {
        text-align: center;
        padding: 8px 12px;
        height: 48px;

        @media(max-width: ${LayoutConst.screen.s}px) {
            padding: 8px 16px;
        }
    }

    th {
      background-color: transparent !important;
      white-space: nowrap;
      padding-top: 0;
      font-size: 15px;
      line-height: 20px;
      font-weight: 400;
      color: ${Colors.galBlack47};
    }

    td:last-child {
        text-align: right;
    }

    tr:nth-child(even) {
  
    }

    @media ${MEDIA.MOBILE} {
      thead {
        display: none;
      }

      tr {
        display: inline-flex;
        
      }
        tbody {
          display: flex;
          flex-flow: column;
          gap: 16px;
        }
    }

`;

export const EditorWrapper = styled(FlexBox)`
  flex-flow: column;
  .add-button {
    max-width: 244px;
    height: 48px;
    max-height: 48px;
    font-weight: 600;

    @media ${MEDIA.LAPTOP} {
      height: 40px;
    }

    * {
      font-size: 17px;
      line-height: 22px;

      @media ${MEDIA.LAPTOP} {
          font-size: 15px;
          line-height: 20px;
      }
    }
  }
`;

export const SectionTitle = styled.div`
  width: 100%;  
  font-size: 30px;
  line-height: 40px;
  color: ${Colors.geoWhite100};
  font-family: Inter;

  @media ${MEDIA.TABLET} {
    font-size: 23px;
    line-height: 27px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;

export const LegalName = styled.div`
  font-size: 23px;
  line-height: 27px;
  color: ${Colors.geoWhite100};
  font-family: Inter;

  @media ${MEDIA.MOBILE} {
    font-size: 17px;
    line-height: 22px;
    max-width: calc(100% - 48px - 16px - 24px);
  }
`;

export const DisplayLinkContainer = styled.div`

  a {
    text-decoration: underline !important;
    cursor: pointer;
    color: ${Colors.galBlack47};
  }

  :not(.required-label) {
    color: ${Colors.galBlack47} !important;
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
  }

  color: ${Colors.galBlack47} !important;
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
`;
import { LayoutConst } from "core";
import { Colors, DropdownListItem, FlexBox, MEDIA } from "@brg/ui";
import styled, { createGlobalStyle } from "styled-components";

export const ApplicationEditorSortableDragStyles = createGlobalStyle`
  .application-editor-sortable-dragged {
    opacity: 1 !important;
    visibility: visible !important;
    z-index: 300100 !important;
    cursor: grabbing !important;
    pointer-events: none;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  }

  tr.application-editor-sortable-dragged {
    display: table;
    width: 100%;
    table-layout: fixed;
    background: #343434 !important;
  }

  tr.application-editor-sortable-dragged td {
    display: table-cell !important;
    vertical-align: middle;
    background: #343434 !important;
  }

  div.application-editor-sortable-dragged {
    width: 100%;
  }

  @media ${MEDIA.MOBILE} {
    tr.application-editor-sortable-dragged {
      display: flex !important;
      flex-flow: column;
      gap: 16px;
      padding: 12px 0;
    }

    tr.application-editor-sortable-dragged td {
      display: block !important;
      width: 100%;
      padding: 0 !important;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  max-width: ${LayoutConst.projectContainer.l}px;
  margin: 0 auto;
  gap: 48px;
  // overflow-y: scroll;
  // height: 100%;
  // margin-bottom: 300px;

  .ui-input_container {
    background-color: ${Colors.zelWhite10};
  }

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    margin-top: 40px;
    max-width: ${LayoutConst.projectContainer.m}px;
  }

  @media ${MEDIA.TABLET}px {
    // padding: 0 20px;
    max-width: calc(100% - 20px);
    margin: 40px auto 0 auto;
  }
`;

export const TdInputContainer = styled.tr`
  div:has(> input[type="checkbox"]) {
    background-color: ${Colors.zelWhite10};
  }

  ${DropdownListItem} {
    background-color: ${Colors.zelWhite10};
    text-align: left;
  }

  @media ${MEDIA.MOBILE} {
    display: inline-flex;
    flex-flow: column;
    gap: 16px;
    padding: 12px 0px;
  }
`;

export const GroupsInputsContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 24px;
  padding: 24px;
  border-radius: 3px;
  border: 1px solid ${Colors.galBlack47};

  div:has(> input[type="checkbox"]) {
    background-color: ${Colors.zelWhite10};
  }

  @media ${MEDIA.MOBILE} {
    padding: 16px 12px;
  }
`;

export const Table = styled.table`
    border-collapse: collapse;
    width: 100%;

    .id-input {
      max-width: 90px;
      min-width: 90px;
    }

    .checkbox-with-label {
        div:last-child {
            white-space: nowrap;
            color: rgba(144, 144, 144, 1);
            font-size: 17px;
            line-height: 22px;
            font-weight: 400;
        }
    }


    td {
        text-align: center;
        padding: 8px 12px;
        height: 48px;

        @media(max-width: ${LayoutConst.screen.s}px) {
            padding: 8px 16px;
        }
    }

    th {
      background-color: transparent !important;
      white-space: nowrap;
      padding-top: 0;
      font-size: 15px;
      line-height: 20px;
      font-weight: 400;
      color: ${Colors.galBlack47};
    }

    td:last-child {
        text-align: right;
    }

    tr:nth-child(even) {
  
    }

    @media ${MEDIA.MOBILE} {
      thead {
        display: none;
      }

      tr {
        display: inline-flex;
        
      }
        tbody {
          display: flex;
          flex-flow: column;
          gap: 16px;
        }
    }

`;

export const EditorWrapper = styled(FlexBox)`
  flex-flow: column;
  .add-button {
    max-width: 244px;
    height: 48px;
    max-height: 48px;
    font-weight: 600;

    @media ${MEDIA.LAPTOP} {
      height: 40px;
    }

    * {
      font-size: 17px;
      line-height: 22px;

      @media ${MEDIA.LAPTOP} {
          font-size: 15px;
          line-height: 20px;
      }
    }
  }
`;

export const SectionTitle = styled.div`
  width: 100%;  
  font-size: 30px;
  line-height: 40px;
  color: ${Colors.geoWhite100};
  font-family: Inter;

  @media ${MEDIA.TABLET} {
    font-size: 23px;
    line-height: 27px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;

export const LegalName = styled.div`
  font-size: 23px;
  line-height: 27px;
  color: ${Colors.geoWhite100};
  font-family: Inter;

  @media ${MEDIA.MOBILE} {
    font-size: 17px;
    line-height: 22px;
    max-width: calc(100% - 48px - 16px - 24px);
  }
`;

export const DisplayLinkContainer = styled.div`

  a {
    text-decoration: underline !important;
    cursor: pointer;
    color: ${Colors.galBlack47};
  }

  :not(.required-label) {
    color: ${Colors.galBlack47} !important;
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
  }

  color: ${Colors.galBlack47} !important;
  font-size: 15px;
  line-height: 20px;
  font-weight: 400;
`;
